import { render, staticRenderFns } from "./CameraCard.vue?vue&type=template&id=67a67a9a"
import script from "./CameraCard.vue?vue&type=script&lang=js"
export * from "./CameraCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports